import { Permission } from './permission';
import { Permit } from './permit';

export class Identity {
    _id?: string;
    _system: boolean = false;

    name?: string;
    token?: string;
    email?: string;
    roles?: string[];
    permit?: Permit;

    constructor(source?: any) {
        if (source) {
            this._id = source._id;
            this._system = source._system;
            this.name = source.name;
            this.token = source.token;
            this.email = source.email;
            this.roles = source.roles;
            this.permit = new Permit(source.permit);
        }
    }

    get valid(): boolean {
        return !!this.token && this.token?.length > 0;
    }

    has<K extends keyof Permission>(permission: Permission, ...keys: K[]): boolean {
        return this._system || permission && !!keys?.some(key => !!permission[key]?.find(role => this.roles?.find(x => x === role)));
    }
}
